import React from 'react';
import { classNames } from '../../utils/format';

export default function FormField({ label, htmlFor, hint, error, required, children, className }) {
  return (
    <div className={classNames('form-field', error && 'form-field--error', className)}>
      {label && (
        <label className="form-label" htmlFor={htmlFor}>
          {label}
          {required && <span className="form-required" aria-hidden> *</span>}
        </label>
      )}
      {children}
      {error ? (
        <div className="form-error">{error}</div>
      ) : hint ? (
        <div className="form-hint">{hint}</div>
      ) : null}
    </div>
  );
}
